/** Additive UI contract. No prices or payouts are calculated in this module. */
export interface AgencyState {
  status: string;
  missing: string[];
  hasDraft: boolean;
  published: boolean;
  effectiveAt: string | null;
  canPublish: boolean;
}
export interface AgencyRelease {
  id: number;
  audience: string;
  version: string;
  title: string;
  content: string;
  content_hash: string;
  summary: string;
  model: string;
  state: AgencyState;
}
export interface AgencyStore {
  id: number;
  name: string;
  is_active: boolean;
  approved: boolean;
  menu_uplift_percent: number;
  clearance?: {
    release_id: number;
    created_at: string;
    verified_details: {
      legalName?: string;
      vatStatus?: string;
      vatNumber?: string;
    };
  } | null;
  legacy_current_version: string | null;
  legacy_acceptance: {
    version: string;
    signedName: string;
    acceptedAt: string;
  } | null;
  agency_acceptance: {
    id: number;
    version: string;
    effectiveAt: string;
    acceptedAt: string;
    signedName: string;
    releaseId: number;
    legalIdentity: Record<string, unknown>;
  } | null;
}
export interface UpliftHistory {
  id: number;
  store_id: number;
  scope: string;
  scope_id: number;
  operation: string;
  previous_value: unknown;
  new_value: unknown;
  effective_at: string;
  administrator_id: number | null;
  source: string;
  reason: string | null;
}
export interface AgencyCompliance {
  releases: AgencyRelease[];
  stores: AgencyStore[];
  upliftHistory: UpliftHistory[];
  vatRegistration: { status: string; verified: boolean };
  deliveryStatus: string;
  driverReviewItems: string[];
  financialReconciliation: string;
  rollout: string;
}
export interface AgencyStatus {
  status: string;
  blocking: false;
  agreement: {
    id: number;
    version: string;
    summary: string;
    state: AgencyState;
  } | null;
  acceptance?: { id: number; accepted_at: string; effective_at: string } | null;
  notice?: string;
}
export interface AgencyDocument extends AgencyRelease {
  acceptance?: { id: number; accepted_at: string; effective_at: string } | null;
  commercialSchedule: {
    shop: { id: number; name: string; menu_uplift_percent: number };
    example: {
      protectedPence: number;
      configuredPercent: number;
      customerPence: number;
      commissionPence: number;
    };
    categories: unknown[];
    items: unknown[];
    pricingRule: string;
    adjustments: string;
  } | null;
  scheduleHash: string | null;
}
export function shopAgencyStatus(store: AgencyStore, now = Date.now()) {
  if (store.agency_acceptance)
    return +new Date(store.agency_acceptance.effectiveAt) <= now
      ? "Active"
      : "Accepted";
  return store.legacy_acceptance?.version === store.legacy_current_version
    ? "Pending"
    : "Unresolved";
}
export const protectedMenuHeadline =
  "KEEP 100% OF YOUR AGREED MENU PRICE — GUARANTEED.";
export const agencyCommercialSummary =
  "Your business receives its full agreed menu price for the items you sell through Ayrshire Hub, subject to any separately agreed adjustments. Ayrshire Hub earns a marketplace commission from the customer-facing item selling price. This commission does not reduce your protected menu price entitlement.";

export interface FoodAgencyDisclosure {agencyActive:boolean;shopId:number;version?:string;effectiveAt?:string;seller?:{legalName:string;tradingName:string;address:string;companyNumber:string|null};role?:string;priceDisclosure?:string;deliveryDisclosure?:string;customerTermsUrl?:string}
